/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Dane zmiany hasla
 */
export interface ChangePasswordResponse { 
    /**
     * Kody odpowiedzi po zmianie hasła
     */
    code?: ChangePasswordResponse.CodeEnum;
}
export namespace ChangePasswordResponse {
    export type CodeEnum = 'OK' | 'ERROR' | 'PASSWORD_NOT_MATCH' | 'CONFLICT_CHANGE' | 'UNAUTHORIZED' | 'CHANGE_PASSWORD';
    export const CodeEnum = {
        OK: 'OK' as CodeEnum,
        ERROR: 'ERROR' as CodeEnum,
        PASSWORD_NOT_MATCH: 'PASSWORD_NOT_MATCH' as CodeEnum,
        CONFLICT_CHANGE: 'CONFLICT_CHANGE' as CodeEnum,
        UNAUTHORIZED: 'UNAUTHORIZED' as CodeEnum,
        CHANGE_PASSWORD: 'CHANGE_PASSWORD' as CodeEnum
    };
}


